export default "__VITE_ASSET__YRiSq7Bq__"